import { OpenBankingAccount } from '../types/openBankingAccount'

export function isOpenBankingAccountDeleted(account: OpenBankingAccount): boolean {
  return !!account.deletedAt || !!account.connection.deletedAt
}
